<script lang="ts" setup>
import { useLang } from '~/composables/useLang'

const { t } = useLang()

defineProps({
  item: {
    type: Object,
    required: true,
  },
})
</script>

<template>
  <div class="flex gap-1">
    <template v-if="item.processing_completed">
      <Tooltip :text="t('site_pro.status.processing_completed')" trigger="hover">
        <i class="fa-solid fa-box-open text-greenDark text-sm" />
      </Tooltip>
    </template>
    <template v-if="parseInt(item.storage.will_start_counting_in) > 10">
      <Tooltip
        :text="t('site_pro.status.storage_fee.warning', { days: item.storage.will_start_counting_in })"
        trigger="hover">
        <i class="fa-regular fa-clock text-greenDark" />
      </Tooltip>
    </template>
    <template v-else-if="parseInt(item.storage.will_start_counting_in) > 0">
      <Tooltip
        :text="t('site_pro.status.storage_fee.warning', { days: item.storage.will_start_counting_in })"
        trigger="hover">
        <i class="fa-regular fa-clock text-yellowDark" />
      </Tooltip>
    </template>
    <template v-else>
      <Tooltip :text="t('site_pro.status.storage_fee.overdue')" trigger="hover">
        <i class="fa-regular fa-clock text-redDark" />
      </Tooltip>
    </template>
  </div>
</template>
